import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { PatientMatchEventProps } from '../../model'
import { EventNotes, FieldsGrid } from '../shared'

export function PatientMatchEvent({
  event,
  searchQuery,
}: {
  event: PatientMatchEventProps
  searchQuery: string
}) {
  return (
    <>
      <div className="flex flex-col gap-0.5 py-[3px]">
        <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
        {event.descriptionText ? (
          <Text
            className="text-text-secondary"
            appearance="BODY2"
          >
            {highlightText(event.descriptionText, searchQuery)}
          </Text>
        ) : null}
        {event.fields ? (
          <FieldsGrid
            fields={event.fields}
            searchQuery={searchQuery}
            userRole={event.userRole}
          />
        ) : null}
      </div>
      {event.notes && event.userRole === 'person' && (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      )}
    </>
  )
}
